import React, {useState, useEffect} from "react";

import { Select, Button, Tooltip, Modal } from "antd";
import { PlayCircleOutlined } from '@ant-design/icons';

import { postData,getData } from '../../config/api-connect';

import moment from 'moment';

import MonthSelector from "../../components/ui/MonthSelector";

import SummaryLayout from '../../components/layout/SummaryLayout'

import { useMonthFilter } from "../../hooks/useMonthFilter";
import { useCityName } from "../../hooks/useCityName";

function Revenue() {

  const { Option } = Select;

  const { selectedMonth, setSelectedMonth } = useMonthFilter();
  const { cityName, setCityName } = useCityName();

  const [summaryData, setSummaryData] = useState([])
  const [summaryLoader, setSummaryLoader] = useState(true);
  const [selectedVenueID, setSelectedVenueID] = useState([])
  const [selectedVenueName, setSelectedVenueName] = useState("");
  const [openPopup, setOpenPopup] = useState(false)
  const [taskMonth, setTaskMonth] = useState(moment()); 

  useEffect(() => {
    get_revenue_summary()
  },[selectedMonth,cityName])
  
  const cityOptions = [
    "Bangalore",
    "Kerala",
    "Hyderabad",
    "Qatar",
    "UAE",
    "Kuwait",
    "Poland",
    "France",
    "Germany",
    "Thailand",
  ];

  const get_revenue_summary = () => {
    setSummaryLoader(true)

    var month = selectedMonth.format('MM')
    var year = selectedMonth.format('YYYY')

    getData(`/finance/get_venue_wise_revenue_summary/?month=${month}&year=${year}&city_name=${cityName}`)
    .then(response =>{
      setSummaryData(response.result)
      setSummaryLoader(false)
    })
    .catch(error => {
      setSummaryLoader(false)
      alert(error.message);
    });
  }

  const revenue_columns = [
    {
      title: "Venue",
      dataIndex: "venue",
    },
    
    ...(cityName === "Kerala"
      ? [{
          title: "City",
          dataIndex: "city",
          align: "center",
        }]
      : []),
    {
      title: "Location",
      dataIndex: "location",
      align: "center"
    },
    {
      title: "Revenue",
      dataIndex: "revenue",
      align: "center",
      render: (value) => Math.round(value).toLocaleString("en-IN"),
    },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Run revenue task">
          <Button
            type="default"
            icon={<PlayCircleOutlined />}
            onClick={() => openRevenueTaskModal(record)}
          />
        </Tooltip>
      ),
    }
  ]

  const openRevenueTaskModal = (record) => {
    setSelectedVenueID(record.venue_id);
    setSelectedVenueName(record.venue);
    setTaskMonth(selectedMonth || moment());
    setOpenPopup(true);
  };

  const handleCloseModal = () => {
    setOpenPopup(false);
    setSelectedVenueID(null);
    setSelectedVenueName("");
  };

  const runRevenueTask = () => {

    var month = selectedMonth.format('MM')
    var year = selectedMonth.format('YYYY')

    postData('/finance/run_revenue_task/', {'venue_id': selectedVenueID, 'month': month, 'year': year })
    .then(response =>{
      handleCloseModal();
      if(response.success){
        get_revenue_summary()
        Modal.success({
          content: response.message,
        });
      }
      else{
        Modal.error({
          content: response.message,
        });
      }
    })
    .catch(error => {
      console.log(error.message);
    });
  }

  const renderRightSideActions = () => (
    <>
      <Select
        placeholder="Select City"
        style={{ width: 160 }}
        value={cityName}
        onChange={(value) => setCityName(value)}
      >
        {cityOptions.map((city) => (
          <Option key={city} value={city}>
            {city}
          </Option>
        ))}
      </Select>

      <MonthSelector
        value={selectedMonth}
        onChange={setSelectedMonth}
      />
    </>
  )

  return (
    <>
      <SummaryLayout
        title="Revenue Summary"
        headerContent={renderRightSideActions()}
        statsLoading={summaryLoader}
        tableProps={{
          rowKey: "venue_id",
          columns: revenue_columns,
          data: summaryData,
          loading: summaryLoader,
          pagination: false,
          bordered: false
        }}
      />

      <Modal
        open={openPopup}
        title={
          <div>
            Run Revenue Task – <b>{selectedVenueName}</b>
          </div>
        }
        onCancel={handleCloseModal}
        footer={[
          <Button key="cancel" onClick={handleCloseModal}>
            Cancel
          </Button>,
          <Button
            key="run"
            type="primary"
            onClick={runRevenueTask}
          >
            Run Revenue Task
          </Button>,
        ]}
      >
        <div style={{ marginTop: 10 }}>
          <div style={{ marginBottom: 8, fontWeight: 500 }}>
            Select Month
          </div>
          <MonthSelector
            value={taskMonth}
            onChange={setTaskMonth}
            style={{ width: "100%" }}
          />
        </div>
      </Modal>

    </>
  );
}

export default Revenue;